export default __webpack_public_path__ + "static/media/top-header3.152dd18c.png";